import React, { useEffect, useState } from "react"
import { Form, Input, InputNumber, Radio, Select, Space } from "antd"
import FooterComponents from "../Footer"
import Loader from "../../../../../../components/Loader"
import TooltipComponents from "../Tooltip"
import { validate } from "../../../../../../utils/functions"
import { TYPE_SURVEY } from "../../../../../../utils/constants"

const { TextArea } = Input
const RadioGroup = Radio.Group
const Option = Select.Option

const FormComponents = (props) => {
  const {
    isLoadingForm,
    formData,
    isLoadingSave,
    updateOtherIndicator,
    match,
  } = props

  const [loading, setLoading] = useState(true)
  const [disabledResult, setDisabledResult] = useState(false)
  const [inputNumberConfig, setInputNumberConfig] = useState({})
  const [disabled, setDisabled] = useState(false)
  const [showFooter, setShowFooter] = useState(false)
  const [measureInProgress, setMeasureInProgress] = useState(false)
  const [form] = Form.useForm()

  useEffect(() => {
    if (isLoadingForm === false) {
      setValueForm()
      setTimeout(() => {
        setLoading(false)
      }, 500)
    }
  }, [isLoadingForm])

  const setValueForm = () => {
    if (validate.exist(formData) && !validate.empty(formData)) {
      const {
        anonymity,
        segmentation_name,
        description,
        calculation_name,
        survey_type_name,
        id_survey_type,
        has_measure_in_progress,
      } = formData

      form.setFieldsValue({
        name: survey_type_name,
        description,
        result: calculation_name,
        segment: segmentation_name,
        anonymity,
      })

      const disableResultOption =
        [
          TYPE_SURVEY.climate.idSurveyType,
          TYPE_SURVEY.leadership.idSurveyType,
        ].includes(id_survey_type) || has_measure_in_progress > 0
      setDisabledResult(disableResultOption)
      setMeasureInProgress(has_measure_in_progress > 0)
      configInputNumber(id_survey_type)
    }
  }

  const getMinimumAnonimityBySurveyType = (id_survey_type) => {
    let minimum = 2;
    switch (id_survey_type) {
      case TYPE_SURVEY.offboarding.idSurveyType:
        minimum = 1
        break;
      case TYPE_SURVEY.onboarding.idSurveyType:
        minimum = 1
        break;
      case TYPE_SURVEY.leadership.idSurveyType:
        minimum = 2
      default:
        break;
    }

    return minimum;
  }

  const configInputNumber = (id_survey_type) => {
    let response = {
      min: 3,
      max: 10,
      defaultValue: 5,
    }
    if (
      [
        TYPE_SURVEY.leadership.idSurveyType,
        TYPE_SURVEY.offboarding.idSurveyType,
        TYPE_SURVEY.onboarding.idSurveyType,
      ].includes(id_survey_type)
    ) {
      response = {
        min: getMinimumAnonimityBySurveyType(id_survey_type),
        max: 10,
        defaultValue: 2,
      }
    }

    setInputNumberConfig(response)
  }

  const onFinish = (values) => {
    const { id } = match.params
    const payload = {
      id,
      params: {
        name: values.name,
        anonymity: values.anonymity,
        description: values.description,
        id_survey_calculation_type: values.result === "Top two box" ? 1 : 2,
      },
    }
    updateOtherIndicator(payload)
  }

  const hasFieldsChange = (allFields) => {
    setShowFooter(true)
    const fieldsRequired = ["anonymity", "name"]
    const hasFieldsInComplete =
      allFields.filter((item) => {
        if (fieldsRequired.includes(item.name[0])) {
          return !validate.empty(item.value)
        }
      }).length !== 2

    setDisabled(hasFieldsInComplete)
  }

  const formComponent = () => {
    return (
      <div className="form-indicator">
        <Form
          layout="vertical"
          form={form}
          autoComplete="off"
          onFinish={(item) => onFinish(item)}
          onFieldsChange={(_, allFields) => hasFieldsChange(allFields)}>
          <Form.Item
            name="name"
            rules={[{ required: true, message: "Campo obligatorio" }]}
            label="Nombre del indicador*">
            <Input className="input-name" maxLength={45} />
          </Form.Item>

          <Form.Item name="description" label="Descripción">
            <TextArea
              placeholder="Escribe aquí una breve descripción de tu indicador..."
              className="input-description"
              maxLength={300}
            />
          </Form.Item>

          <Form.Item
            name="result"
            rules={[{ required: true, message: "Campo obligatorio" }]}
            label="Resultados">
            <RadioGroup defaultValue="Top two box" disabled={disabledResult}>
              <div className="options-results">
                <div className="options-results-title add-tooltip">
                  <div>Criterio de cálculo*</div>
                  <div className="add-tooltip-icon">
                    <TooltipComponents
                      name={
                        measureInProgress
                          ? "measureInProgress"
                          : "calculationCriteria"
                      }
                    />
                  </div>
                </div>
              </div>
              <Space direction="vertical">
                <Radio value="Top two box">Top two box</Radio>
                <Radio value="Promedio">Promedio</Radio>
              </Space>
            </RadioGroup>
          </Form.Item>

          <Form.Item
            name="segment"
            rules={[{ required: true, message: "Campo obligatorio" }]}
            label={
              <div className="add-tooltip">
                <div>Segmentación*</div>
                <div className="add-tooltip-icon">
                  <TooltipComponents name="segments" />
                </div>
              </div>
            }>
            <Select
              defaultValue="Divisiones"
              disabled
              className="drop-down-segment">
              <Option value="Divisiones">Divisiones</Option>
              <Option value="Líderes">Líderes</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="anonymity"
            rules={[{ required: true, message: "Campo obligatorio" }]}
            label={
              <div className="add-tooltip">
                <div>Anonimato*</div>
                <div className="add-tooltip-icon">
                  <TooltipComponents name="anonymity" />
                </div>
              </div>
            }>
            <InputNumber
              className="input-number-anonymity"
              {...inputNumberConfig}
            />
          </Form.Item>

          {showFooter && (
            <FooterComponents
              onResetForm={setValueForm}
              disabled={disabled}
              isLoadingSave={isLoadingSave}
            />
          )}
        </Form>
      </div>
    )
  }

  return loading ? <Loader height="80vh" /> : formComponent()
}

FormComponents.propTypes = {}

export default FormComponents
